import { API } from 'data';
import { __MergePaginationPage } from 'scripts/paginationQuery';
import { RestAPI } from 'scripts';
import { PaginationType, PostType } from 'types';

export const __MY_BOOKMARKS_PAGE_SIZE = 18;

export type __MyBookmarkItemType = { id: number; post: PostType<'list'> };

export function __FetchMyBookmarks(
    page: number,
    prev?: PaginationType<__MyBookmarkItemType>,
): Promise<PaginationType<__MyBookmarkItemType>> {
    return RestAPI.get<PaginationType<__MyBookmarkItemType>>(API.posts.myBookmarks, {
        page_size: __MY_BOOKMARKS_PAGE_SIZE,
        ordering: '-created_at',
        page,
    }).then((res) => __MergePaginationPage(page, res.data, prev));
}
